import { useEffect, useRef } from 'react';
import { usePageContent } from '@/context/ContentContext';

export default function FeaturesSection() {
  const c = usePageContent('home');
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const els = entry.target.querySelectorAll('.reveal');
            els.forEach((el, i) => {
              setTimeout(() => {
                el.classList.add('animate-in');
              }, i * 150);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative w-full py-20 md:py-32 overflow-hidden bg-[#1a1a1a]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20elegant%20background%20with%20scattered%20golden%20house%20number%20plates%20artistic%20composition%2C%20luxury%20brand%20aesthetic%20with%20dark%20moody%20atmosphere%20and%20gold%20accents%2C%20premium%20design%20background%20with%20soft%20bokeh%20lights%2C%20various%20brass%20and%20acrylic%20number%20plates%20on%20dark%20surface%2C%20warm%20amber%20lighting&width=1600&height=900&seq=features-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#1a1a1a]/80" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-[1450px] mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out font-heading text-3xl md:text-4xl font-bold text-white mb-6">
            {c.features_heading}
          </h2>
          <p className="reveal opacity-0 translate-y-4 transition-all duration-700 delay-100 ease-out text-base text-white/70 leading-relaxed mb-8">
            {c.features_text}
          </p>
        </div>

        <div className="reveal opacity-0 translate-y-4 transition-all duration-700 delay-200 ease-out text-center">
          <a
            href="#products"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-foreground-950 font-label text-sm font-medium rounded-full hover:bg-white/90 transition-colors whitespace-nowrap"
          >
            {c.features_cta}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>

      <style>{`
        .reveal.animate-in {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>
    </section>
  );
}